import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {useSelector, useDispatch} from 'react-redux'
import dummyImg from '../../../../static/images/avatar/1.jpg';
import InlineLoader from '../../../helpers/InlineLoader';
import { FileIcon, defaultStyles } from 'react-file-icon';
import { downloadURI, formatUrl, downloadFileFromUrl, downloadFunction } from '../../../utils/urls';
import moment from "moment"
import BtnAddToFavourities from '../../../helpers/BtnAddToFavourities';
import {OverlayTrigger, Tooltip} from "react-bootstrap"
import ModalUpdateStatus from '../../../helpers/Files/ModalUpdateStatus';
import NameComponent from '../../../helpers/Files/NameComponent';
import ModalShowFile from '../../../helpers/ShowFile';
import ModalRenameFile from '../../../helpers/RenameFile';
import ModalDeleteFile from '../../../helpers/DeleteFile';
import ModalShareFile from '../../../helpers/ModalShareFile';
import BtnAddToSymbolicLink from '../../../helpers/BtnAddToSymbolicLink';


function SymbolicLinks() {

    let url = "/filemanager/symbolic-link/";
    const session = useSelector(state => state.session);
    const userPermissions = session.userData.permissions;

    const [loading, setloading]   = useState(true);
    const [search,  setsearch]    = useState(true);
    const [data,    setdata]      = useState(null);

    const [folderSelected, setfolderSelected]       = useState(null);
    const [fileSelected,   setfileSelected]       = useState(null);

    const [showModalStatus, setShowModalStatus] = useState(false);

    const dispatch        = useDispatch();
    const downloadList    = useSelector(state => state.dashboard.download_list);
    console.log("Lista de descargas:",downloadList);

    const getData = () => {
      axios.get(url).then((res) => {
        console.log(res.data);
        setdata(res.data);
        setloading(false);
      }).catch((err) => {
        console.error(err);
      });
    }
    
    useEffect(() => {
      if(loading){
        if(search){
          setsearch(false);
          getData();
        }
      }
    }, []);

    //show
    const [showModalShowFile, setShowModalShowFile] = useState(false);
    const handleCloseModalShowFile = () => {
      setShowModalShowFile(false);
    }
    const handleShowModalShowFile = () => {
      setShowModalShowFile(true)
    };

    const showFileNow = (file) => {
      setfileSelected(file);
      handleShowModalShowFile();
    }

    //rename
    const [showModalRenameFile, setShowModalRenameFile] = useState(false);
    const handleCloseModalRenameFile = () => {
      setShowModalRenameFile(false);
    }
    const handleShowModalRenameFile = () => {
      setShowModalRenameFile(true)
    };

    const RenameFileNow = (file) => {
      setfileSelected(file);
      handleShowModalRenameFile();
    }

    //share
    const [showModalShareFile, setShowModalShareFile] = useState(false);
    const handleCloseModalShareFile = () => {
      setShowModalShareFile(false);
    }
    const handleShowModalShareFile = () => {
      setShowModalShareFile(true)
    };

    const shareFileNow = (file) => {
      setfileSelected(file);
      handleShowModalShareFile();
    }

    //delete
    const [showModalDeleteFile, setShowModalDeleteFile] = useState(false);
    const handleCloseModalDeleteFile = () => {
      setShowModalDeleteFile(false);
    }
    const handleShowModalDeleteFile = () => {
      setShowModalDeleteFile(true)
    };

    const deleteFileNow = (file) => {
      setfileSelected(file);
      handleShowModalDeleteFile();
    }

    const refresh = () => {
      getData();
    }

    const deleteFileBYid = (id) => {
      let listWithoutFile = data.filter(item => item.file.id !== id);
      console.log(id);
      console.log(listWithoutFile);
      setdata(listWithoutFile);
    }

    return (
        <div className="">
        <div className="row mb-5 align-items-center">
          <div className="col-lg-12">
            <div className="card m-0 ">
              <div className="card-body py-3 py-md-2">
                <div className="row align-items-center">
                  <div className="col-md-5 mb-md-0">
                    
                    <h3 className="mb-0 text-black font-w600 fs-20">Accesos directos</h3>
                      
                  </div>
                </div>							
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">	
                {(!loading && data !== null) 
                ?
                  <div>
                    <div className="table-responsive table-hover fs-14">
                      <div className="dataTables_wrapper no-footer"><table className="table display mb-4 dataTablesCard fs-14 dataTable no-footer" id="example5" role="grid" aria-describedby="example5_info">
                          <thead>
                            <tr role="row">
                              <th style={{width: '250px'}} className="sorting_asc" tabIndex={0} aria-controls="example5" rowSpan={1} colSpan={1} aria-sort="ascending" aria-label="Archivo: activate to sort column descending">Archivo</th>
                              <th className="d-none text-center d-lg-table-cell sorting" tabIndex={0} aria-controls="example5" rowSpan={1} colSpan={1} aria-label="Categoría: activate to sort column ascending" style={{width: '116px'}}>Categoría</th>
                              <th className="text-center sorting" tabIndex={0} aria-controls="example5" rowSpan={1} colSpan={1} aria-label="Acción: activate to sort column ascending" style={{width: '351px'}}>Acción</th>
                            </tr>
                          </thead>
                          {(Array.isArray(data) && data.length > 0) ?
                          <tbody>
                            {data.map((item, key) => {

                              let filename = item.file.name.split('.');
                              let formattext = filename[filename.length - 1].toLowerCase();

                              return (
                                <tr key={key} role="row" className="odd">
                                  <td className="sorting_1">
                                    <div className="media align-items-center">
                                      {(item.file.thumbnail !== null && item.file.thumbnail !== '') 
                                      ?
                                        <img 
                                          className="img-fluid rounded mr-3 d-xl-inline-block" 
                                          width={70} 
                                          src={formatUrl(item.file.thumbnail)} 
                                          alt="Carpeta" 
                                        />
                                      :
                                        <div style={{ width: "70px", marginRight: "15px" }}>
                                          <div style={{ width: "70px"}}></div>
                                          <FileIcon radius={12} extension={formattext} {...defaultStyles[formattext]} />
                                        </div>
                                      }
                                      <div className="media-body">
                                          <NameComponent
                                            item={item.file} 
                                            id={item.file.id} 
                                            name={item.file.name} 
                                            status={item.file.status} 
                                            status_name={item.file.status_name} 
                                            selectItem={setfileSelected}
                                            showModalStatus={() => setShowModalStatus(true)}
                                          />
                                      </div>
                                    </div>
                                  </td>
                                  <td className="d-none d-lg-table-cell text-center">
                                    {item.file.category !== null ? item.file.category.breadcrumb : "--"}
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-start">
                                        {item.permissions.can_rename &&
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                <Tooltip id={`tooltip-btn-renombrar-file-unidad-${item.id}`}>
                                                    Renombrar
                                                </Tooltip>
                                                }
                                            >
                                            <button onClick={(e) => RenameFileNow(item.file)} className="py-2 h-auto btn btn-warning btn_off  btn-sm mr-2 px-4">
                                                <i className="fas fa-file-signature"></i>
                                                <span className="d-none">Renombrar</span>
                                            </button>
                                            </OverlayTrigger>
                                        }

                                        {item.permissions.can_share &&
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-btn-compartir-file-unidad-${item.file.id}`}>
                                                    Compartir
                                                    </Tooltip>
                                                }
                                                >
                                                <button onClick={(e) => shareFileNow(item.file)} href="" className="py-2 h-auto btn btn-primary btn_off btn-sm px-4">
                                                <i className="fa fa-share-alt" /> 
                                                <span className="d-none">Compartir</span>
                                                </button>
                                            </OverlayTrigger>
                                        }

                                        {(item.permissions.can_download) &&
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-btn-dowload-file-favourities-${item.id}`}>
                                                        Descargar
                                                    </Tooltip>
                                                }
                                            >
                                            <button 
                                                onClick={(e) => downloadFileFromUrl(e, formatUrl(item.file.file), item.file.name, downloadFunction, item.file, dispatch, downloadList)}
                                                className=" btn btn-info btn_off h-auto py-2 btn-sm ml-2 px-4">
                                                <i className="fa fa-download" /> 
                                                <span className="d-none">Descargar</span>
                                            </button>
                                            </OverlayTrigger>
                                        }

                                        {item.permissions.can_preview &&
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                <Tooltip id={`tooltip-btn-show-file-favourities-${item.id}`}>
                                                    Previsualizar
                                                </Tooltip>
                                                }
                                            >
                                            <button onClick={(e) => showFileNow(item.file)} className="py-2 h-auto btn btn-success btn_off  btn-sm ml-2 px-4">
                                                <i className="fa fa-eye" /> 
                                                <span className="d-none">Previsualizar</span>
                                            </button>
                                            </OverlayTrigger>
                                        }

                                        {userPermissions.can_create_and_delete_symbolic_links &&
                                            <BtnAddToSymbolicLink updateOnChage={(iditem) => deleteFileBYid(iditem)} status={true} itemId={item.file.id} />
                                        }

                                        {item.permissions.can_delete &&
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                <Tooltip id={`tooltip-btn-delete-file-unidad-${item.id}`}>
                                                    Eliminar
                                                </Tooltip>
                                                }
                                            >
                                            <button onClick={(e) => deleteFileNow(item.file)} className="py-2 btn btn-danger btn_off  btn-sm ml-2 px-4">
                                                <i className="fa fa-trash" /> 
                                                <span className="d-none">Eliminar</span>
                                            </button>
                                            </OverlayTrigger>
                                        }
                                    </div>
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                          :
                          <tbody>
                            <tr className="odd">
                              <td className="text-center" colSpan="4">
                                <i className="fa fa-exclamation-triangle mr-2"></i>Sin resultados encontrados
                              </td>
                            </tr>
                          </tbody>
                          }
                        </table>

                        {/* 
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="dataTables_info" id="example5_info" role="status" aria-live="polite">
                              Showing 1 to 1 of 1 entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers" id="example5_paginate">
                              <a 
                                className="paginate_button previous disabled" 
                                aria-controls="example5" 
                                data-dt-idx={0} 
                                tabIndex={0} 
                                id="example5_previous"
                              >
                                  Previous
                              </a>
                              <span>
                                  <a 
                                    className="paginate_button current" 
                                    aria-controls="example5" 
                                    data-dt-idx={1} 
                                    tabIndex={0}
                                  >
                                      1
                                  </a>
                              </span>
                              <a 
                                className="paginate_button next disabled" 
                                aria-controls="example5" 
                                data-dt-idx={2} 
                                tabIndex={0} 
                                id="example5_next"
                              >
                                  Next
                              </a>
                          </div>
                        </div>
                        */}
                        </div>
                    </div>
                  </div>
                :
                  <InlineLoader />
                }
          </div>
        </div>

        {userPermissions.can_share_files &&
          <ModalShareFile  refresh={refresh}    file={fileSelected}     show={showModalShareFile}       close={handleCloseModalShareFile} />
        }
        <ModalRenameFile   refresh={refresh}    file={fileSelected}     show={showModalRenameFile}      close={handleCloseModalRenameFile} />
        <ModalDeleteFile   refresh={refresh}    file={fileSelected}     show={showModalDeleteFile}      close={handleCloseModalDeleteFile} />
        <ModalShowFile     refresh={refresh}    file={fileSelected}     show={showModalShowFile}        close={handleCloseModalShowFile} />
        <ModalUpdateStatus refresh={refresh}    file={fileSelected}     show={showModalStatus}          close={() => setShowModalStatus(false)} />
      </div>
    )
}

export default SymbolicLinks
